import React, { memo, FC } from 'react'
import { classNames } from '@dt/fe-utils'
import './index.scss'

// props
interface IProps extends React.HTMLAttributes<HTMLElement> {
  /** icon图标库 */
  icon?: string;
  /** icon名称 */
  name: string;
  /** icon颜色 */
  color?: string;
  /** 大小 */
  size?: number;
}

const Icon: FC<IProps> = (props) => {
  let { icon = 'iconfont', name, className, style, color, size } = props

  if (color || size) {
    style = {
      color,
      fontSize: size ? size + 'px' : undefined,
      ...style
    }
  }

  return (
    <i
      {...props}
      className={classNames(
        icon,
        `${icon === 'dicon' ? 'dicon' : 'icon'}-${name}`,
        className
      )}
      style={style}
    />
  )
}

export default memo(Icon)
